import parseColor from 'color';

// font sizes

export const h1FontSize = 28;

export const largeFontSize = 16;
export const defaultFontSize = 14;
export const smallFontSize = 12;

// font weight

export const normalFontWeight = 400;
export const boldFontWeight = 500;

// generic colors

export const shadowColor = 'rgba(0, 0, 0, 0.25)';

export const primaryTextColor = '#333';
export const secondaryTextColor = '#777';
export const disabledTextColor = '#ccc';

export const brandColor = '#4a90e2';
export const redColor = '#e53935';
export const orangeColor = '#F2692C';
export const greenColor = '#059933';

// navbar colors

export const navbarBgColor = '#333';
export const navbarBg2Color = brandColor;

// extras

export const defaultDateFormat = 'd MMMM yyyy';

export function rgba(css, alpha) {
  return parseColor(css).alpha(alpha).rgb().string();
}

export function darken(css, ratio) {
  return parseColor(css).darken(ratio).rgb().string();
}

export function lighten(css, ratio) {
  return parseColor(css).lighten(ratio).rgb().string();
}

export const mediaSizes = {
  'lg': '@media (min-width: 1201px)',
  'md': '@media (max-width: 960px)',
  'sm': '@media (max-width: 768px)',
  'xs': '@media (max-width: 420px)',
};
